module.exports = __webpack_public_path__ + "img/download-app.95cc9f65.png";